import { Component, ViewEncapsulation } from '@angular/core';
import { RouterstoreService } from 'src/app/service/routerstore.service';
import { Router, ActivatedRoute, Event, NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
  // encapsulation: ViewEncapsulation.None
})
export class AppComponent {

  title = 'bootDash';

  constructor(public router: Router, public route: ActivatedRoute, public rsService: RouterstoreService) {
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        rsService.current_url_service(this.router.url);        
      }
    })
  }

}
